import { HeaderComponent as HeaderComponent_ } from "./interfaces/base";
import { useAppSelector } from "../../store/hooks";
import RenderChildren from "./RenderChildren";
import styled from "@emotion/styled";
import React from "react";
import {
  getBuilderDomId,
  getComponentFromStructureMap,
  matchesEditorTarget,
} from "./utilities/componentIdentity";

const Header = styled("header")(
  null,
  (props) =>
    function (props: any) {
      return { ...props["data-style"] };
    }
);
export default function HeaderComponent({
  id,
  uuid,
  attributes,
  childElements,
  childWebpageComponentRelations,
}: HeaderComponent_) {
  const editorId = useAppSelector((state) => state.textEditor?.get("id"));
  const component = (useAppSelector((state) =>
    getComponentFromStructureMap(state.builder.structure.components, uuid ?? id)
  ) as HeaderComponent_) ?? ({
    id: typeof id === "number" ? id : -1,
    parent_id: null,
    childElements: childElements ?? [],
    childWebpageComponentRelations: childWebpageComponentRelations ?? [],
    sort_order: 0,
    type: "header",
    uuid: uuid ?? null,
    version: 1,
    webpage_id: 0,
    attributes,
  } as HeaderComponent_);

  const domId =
    getBuilderDomId({ id, uuid }) ||
    getBuilderDomId({ id: component.id, uuid: component.uuid });

  const isBuilder = document.getElementById("BuilderContent");

  // let childComponents: AllComponents[] = [];

  // let c;

  // if (childWebpageComponentRelations) {
  //   childWebpageComponentRelations.map((cr) => {
  //     c = structure.components[cr.child_id];
  //     if (c) {
  //       childComponents.push(c);
  //     }
  //   });
  // }

  // const logoComponent = childComponents.find(
  //   (x) => x && x.type === "logo"
  // ) as LogoComponent_;
  // const navComponent = childComponents.find(
  //   (x) => x && x.type === "nav"
  // ) as NavComponent_;
  // const cartComponent = childComponents.find(
  //   (x) => x && x.type === "cart"
  // ) as CartComponent_;

  // const languageComponent = childComponents.find(
  //   (x) => x && x.type === "language-select"
  // ) as LanguageComponent_;
  // TODO: make better

  return (
    <Header
      id={domId || undefined}
      data-style={attributes.styles ?? ""}
      data-component-type="header"
      className={
        "builder-component builder-component__header " +
        (attributes.classes ?? "") +
        (matchesEditorTarget({ id, uuid }, editorId)
          ? " builder-component--active"
          : "")
      }
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        zIndex: isBuilder && 2,
        width: "100%",
        top:
          attributes.styles.position === "sticky" && isBuilder ? "0px" : "0px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",

          width: "100%",
          maxWidth:
            component &&
            component.attributes &&
            component.attributes.headerWidthNumber &&
            component.attributes.headerWidthNumber !== 0
              ? `${component.attributes.headerWidthNumber}${
                  component.attributes.headerWidthUnit
                    ? component.attributes.headerWidthUnit
                    : "px"
                }`
              : "unset",
        }}
      >
        <RenderChildren
          key={`${domId || "header"}-children`}
          childWebpageComponentRelations={childWebpageComponentRelations}
        />
      </div>
    </Header>
  );
}
